import React, { useEffect } from 'react';
import { usePageTitle } from '../hooks/usePageTitle.js';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore.js';
import { LandingNavbar } from '../components/landing/LandingNavbar.js';
import { LandingHero } from '../components/landing/LandingHero.js';
import { LandingFeatures } from '../components/landing/LandingFeatures.js';
import { LandingFocusShowcase } from '../components/landing/LandingFocusShowcase.js';
import { LandingCtaBanner } from '../components/landing/LandingCtaBanner.js';
import { LandingFooter } from '../components/landing/LandingFooter.js';

export const LandingPage: React.FC = () => {
  usePageTitle('صفحه اصلی');
  const { isAuthenticated, setGuestMode } = useAuthStore();
  const navigate = useNavigate();

  // Redirect authenticated visitors directly to dashboard
  useEffect(() => {
    if (isAuthenticated) {
      navigate('/dashboard', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  const handleGuestAccess = () => {
    setGuestMode();
    navigate('/dashboard');
  };

  return (
    <div
      className="min-h-full bg-base-100 text-base-content selection:bg-primary selection:text-white"
      dir="rtl"
    >
      {/* 1. Public Sticky Navigation Bar */}
      <LandingNavbar />

      {/* Main Content Sections */}
      <main>
        {/* 2. Hero Section with Realistic Studio Notation Mockup */}
        <LandingHero onGuestClick={handleGuestAccess} />

        {/* 3. 4 Core Feature Pillars */}
        <LandingFeatures />

        {/* 4. Focus HUD Showcase */}
        <LandingFocusShowcase />

        {/* 5. Pre-Footer High-Conversion Banner */}
        <LandingCtaBanner onGuestClick={handleGuestAccess} />
      </main>

      {/* 6. RTL Persian Footer */}
      <LandingFooter />
    </div>
  );
};

export default LandingPage;
